import axios from 'axios';
import { loginreq, req , reqJson } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("post", "/yunyue-houtai/login/adminLogin", params) };
//获取菜单列表
export const loadMenuList = (params) => { return req("post", "/yunyue-houtai/admin/loadMenuList", params) };
// 菜单管理-创建菜单
export const createMenu = (params) => { return req("post", "/yunyue-houtai/admin/createMenu"  , params) };
//获取角色列表
export const loadRoleList = (params) => { return req("post", "/yunyue-houtai/admin/loadRoleList"  , params) };
// 删除角色
export const deleteRole = (params) => { return req("post", "/yunyue-houtai/admin/deleteRole"  , params) };
// 获取系统用户
export const loadAdminUserList = (params) => { return req("post", "/yunyue-houtai/admin/loadAdminUserList"  , params) };
// 删除菜单
export const deleteMenu = (params) => { return req("post", "/yunyue-houtai/admin/deleteMenu"  , params) };
// 修改菜单
export const updateMenu = (params) => { return req("post", "/yunyue-houtai/admin/updateMenu"  , params) };
// 新建角色
export const createRole = (params) => { return req("post", "/yunyue-houtai/admin/createRole"  , params) };
// 修改角色
export const updateRole = (params) => { return req("post", "/yunyue-houtai/admin/updateRole"  , params) };
// 创建员工
export const createAdminUser = (params) => { return req("post", "/yunyue-houtai/admin/createAdminUser"  , params) };
// 删除系统用户
export const deleteAdminUser = (params) => { return req("post", "/yunyue-houtai/admin/deleteAdminUser"  , params) };
// 修改系统用户
export const updateAdminUser = (params) => { return req("post", "/yunyue-houtai/admin/updateAdminUser"  , params) };
// 获取注册用户列表
export const getCustomerList = (params) => { return req("post", "/yunyue-houtai/customer/getCustomerList"  , params) };
// 获取注册用户列表-分页
export const loadCustomerList = (params) => { return req("post", "/yunyue-houtai/customer/loadCustomerList"  , params) };
// 获取广告位
export const loadInfomercialListNoPage = (params) => { return req("post", "/yunyue-houtai/admin/loadInfomercialListNoPage"  , params) };
// 获取广告位分页
export const loadInfomercialList = (params) => { return req("post", "/yunyue-houtai/admin/loadInfomercialList"  , params) };
// 获取系统配置
export const loadConfigList = (params) => { return req("post", "/yunyue-houtai/admin/loadConfigList"  , params) };
// 修改系统配置
export const updateConfig = (params) => { return req("post", "/yunyue-houtai/admin/updateConfig"  , params) };
// 获取反馈列表
export const loadFeedbackList = (params) => { return req("post", "/yunyue-houtai/admin/loadFeedbackList"  , params) };
// 获取支付订单列表
export const loadPayOrderList = (params) => { return req("post", "/yunyue-houtai/order/loadPayOrderList"  , params) };
// 获取订单列表
export const loadRecoverOrderList = (params) => { return req("post", "/yunyue-houtai/order/loadRecoverOrderList"  , params) };
// 创建系统配置
export const createConfig = (params) => { return req("post", "/yunyue-houtai/admin/createConfig"  , params) };
// 获取app升级列表
export const loadAppVersionList = (params) => { return req("post", "/yunyue-houtai/admin/loadAppVersionList"  , params) };
// 创建广告位
export const createInfomercial = (params) => { return req("post", "/yunyue-houtai/admin/createInfomercial"  , params) };
// 获取销售端用户列表
export const loadStoreUserList = (params) => { return req("post", "/yunyue-houtai/store/loadStoreUserList"  , params) };

// 创建商户
export const createStoreUser = (params) => { return req("post", "/yunyue-houtai/store/createStoreUser"  , params) };
// 修改商户
export const updateStoreUser = (params) => { return req("post", "/yunyue-houtai/store/updateStoreUser"  , params) };
// 获取未绑定机器
export const getMachineListNoBind = (params) => { return req("post", "/yunyue-houtai/admin/getMachineListNoBind"  , params) };
// 绑定机器
export const bindMachine = (params) => { return req("post", "/yunyue-houtai/store/bindMachine"  , params) };
// 解绑机器
export const unBindMachine = (params) => { return req("post", "/yunyue-houtai/store/unBindMachine"  , params) };
// 修改广告位
export const updateInfomercial = (params) => { return req("post", "/yunyue-houtai/admin/updateInfomercial"  , params) };
// 删除广告位
export const delInfomercial = (params) => { return req("post", "/yunyue-houtai/admin/delInfomercial"  , params) };
// 创建App升级
export const createAppVersion = (params) => { return req("post", "/yunyue-houtai/admin/createAppVersion"  , params) };

// 获取分成规则
export const loadDivisionList = (params) => { return req("post", "/yunyue-houtai/store/loadDivisionList"  , params) };
// 编辑分成规则
export const updateDivision = (params) => { return req("post", "/yunyue-houtai/store/updateDivision"  , params) };
// 获取通道列表
export const loadPayChannelList = (params) => { return req("post", "/yunyue-houtai/admin/loadPayChannelList"  , params) };
// 创建支付通道
export const savePayChannel = (params) => { return req("post", "/yunyue-houtai/admin/savePayChannel"  , params) };
// 获取订单收益详情
export const getDivisionOrder = (params) => { return req("post", "/yunyue-houtai/order/getDivisionOrder"  , params) };
// 导出付费订单
export const exportExcel = (params) => { return req("post", "/yunyue-houtai/order/exportExcel"  , params) };
// 获取积分收支记录
export const loadIntegralRecordList = (params) => { return req("post", "/yunyue-houtai/activity/loadIntegralRecordList"  , params) };
// 获取可选任务列表
export const getTaskListForNew = (params) => { return req("post", "/yunyue-houtai/activity/getTaskListForNew"  , params) };
// 获取任务列表
export const loadTaskList = (params) => { return req("post", "/yunyue-houtai/activity/loadTaskList"  , params) };
// 创建任务
export const saveOrUpdateTask = (params) => { return req("post", "/yunyue-houtai/activity/saveOrUpdateTask"  , params) };
// 修改任务排序
export const changeTaskSort = (params) => { return req("post", "/yunyue-houtai/activity/changeTaskSort"  , params) };
// 删除任务
export const deleteTask = (params) => { return req("post", "/yunyue-houtai/activity/deleteTask"  , params) };
// 获取商品列表
export const loadGoodsList = (params) => { return req("post", "/yunyue-houtai/goods/loadGoodsList"  , params) };
// 商品状态变更
export const updateGoodsStatus = (params) => { return req("post", "/yunyue-houtai/goods/updateGoodsStatus"  , params) };
// 商品获取库存记录
export const loadGoodsInventoryRecordList = (params) => { return req("post", "/yunyue-houtai/goods/loadGoodsInventoryRecordList"  , params) };
// 获取商品附件列表
export const loadGoodsFileList = (params) => { return req("post", "/yunyue-houtai/goods/loadGoodsFileList"  , params) };
// 上传商品图片
export const deleteGoodsFile = (params) => { return req("post", "/yunyue-houtai/goods/deleteGoodsFile"  , params) };
// 修改商品图片排序
export const changeFileSort = (params) => { return req("post", "/yunyue-houtai/goods/changeFileSort"  , params) };
// 删除商品
export const deleteGoods = (params) => { return req("post", "/yunyue-houtai/goods/deleteGoods"  , params) };
// 获取分享配置
export const loadShareConfigList = (params) => { return req("post", "/yunyue-houtai/admin/loadShareConfigList"  , params) };
// 删除分享配置
export const deleteShareConfig = (params) => { return req("post", "/yunyue-houtai/admin/deleteShareConfig"  , params) };
// 获取商品订单列表
export const loadGoodsOrderList = (params) => { return req("post", "/yunyue-houtai/order/loadGoodsOrderList"  , params) };
// 商品订单详情
export const getGoodsOrderDetail = (params) => { return req("post", "/yunyue-houtai/order/getGoodsOrderDetail"  , params) };
// 查看物流
export const getLogistics = (params) => { return req("post", "/yunyue-houtai/order/getLogistics"  , params) };
// 删除物流附件
export const deleteLogisticsFile = (params) => { return req("post", "/yunyue-houtai/order/deleteLogisticsFile"  , params) };
// 入库单列表
export const loadStorageOrderList = (params) => { return req("post", "/yunyue-houtai/inventory/loadStorageOrderList"  , params) };
// 创建入库单
// export const createStorageOrder = (params) => { return req("post", "/yunyue-houtai/inventory/createStorageOrder"  , params) };
// 入库单详情
export const getStorageOrderDetail = (params) => { return req("post", "/yunyue-houtai/inventory/getStorageOrderDetail"  , params) };
// 撤销入库单
export const revokeStorageOrder = (params) => { return req("post", "/yunyue-houtai/inventory/revokeStorageOrder"  , params) };
// 校验sn码
export const checkMachineId = (params) => { return req("post", "/yunyue-houtai/inventory/checkMachineId"  , params) };
// 平台总览
export const getTotal = (params) => { return req("post", "/yunyue-houtai/inventory/getTotal"  , params) };
// 获取机器列表
export const loadMachineList = (params) => { return req("post", "/yunyue-houtai/inventory/loadMachineList"  , params) };
// 获取机器详情
export const getMachine = (params) => { return req("post", "/yunyue-houtai/inventory/getMachine"  , params) };
// 修改机器系统模式
export const updateMachineMode = (params) => { return req("post", "/yunyue-houtai/inventory/updateMachineMode"  , params) };
// 创建销售单
export const createSaleOrder = (params) => { return req("post", "/yunyue-houtai/inventory/createSaleOrder"  , params) };
// 获取销售单列表
export const loadSaleOrderList = (params) => { return req("post", "/yunyue-houtai/inventory/loadSaleOrderList"  , params) };
// 销售单详情
export const getSaleOrderDetail = (params) => { return req("post", "/yunyue-houtai/inventory/getSaleOrderDetail"  , params) };
// 撤销销售单
export const revokeSaleOrder = (params) => { return req("post", "/yunyue-houtai/inventory/revokeSaleOrder"  , params) };
// 出库列表
export const loadOutOrderList = (params) => { return req("post", "/yunyue-houtai/inventory/loadOutOrderList"  , params) };
// 创建出库单
export const createOutOrder = (params) => { return req("post", "/yunyue-houtai/inventory/createOutOrder"  , params) };
// 撤销出库
export const revokeOutOrder = (params) => { return req("post", "/yunyue-houtai/inventory/revokeOutOrder"  , params) };
// 获取出库详情
export const getOutOrderDetail = (params) => { return req("post", "/yunyue-houtai/inventory/getOutOrderDetail"  , params) };
// 出库
export const doOut = (params) => { return req("post", "/yunyue-houtai/inventory/doOut"  , params) };
// 修改物流
export const saveLogistics = (params) => { return req("post", "/yunyue-houtai/inventory/saveLogistics"  , params) };
// 错误码列表
export const loadErrorList = (params) => { return req("post", "/yunyue-houtai/admin/loadErrorList"  , params) };
// 保存错误码
export const saveError = (params) => { return req("post", "/yunyue-houtai/admin/saveError"  , params) };
// 删除错误码
export const deleteError = (params) => { return req("post", "/yunyue-houtai/admin/deleteError"  , params) };
// 商家认证
export const authentica = (params) => { return req("post", "/yunyue-houtai/business/authentica"  , params) };
// 维修替换
export const replaceMachine = (params) => { return req("post", "/yunyue-houtai/inventory/replaceMachine"  , params) };
// 恢复机器
export const restoreMachine = (params) => { return req("post", "/yunyue-houtai/inventory/restoreMachine"  , params) };
// 获取替换记录
export const loadMachineReplaceList = (params) => { return req("post", "/yunyue-houtai/inventory/loadMachineReplaceList"  , params) };
// 查询机器列表
export const queryLoadMachineList = (params) => { return req("post", "/yunyue-houtai/admin/loadMachineList"  , params) };
// 查询商家列表
export const queryLoadBusinessUserList = (params) => { return req("post", "/yunyue-houtai/admin/loadBusinessUserList"  , params) };
// 获取行业列表
export const loadTradeList = (params) => { return req("post", "/yunyue-houtai/charge/loadTradeList"  , params) };
// 保存行业信息
export const saveTrade = (params) => { return req("post", "/yunyue-houtai/charge/saveTrade"  , params) };
// 删除行业
export const deleteTrade = (params) => { return req("post", "/yunyue-houtai/charge/deleteTrade"  , params) };
// 获取收银系统商户列表
export const loadChargeUserList = (params) => { return req("post", "/yunyue-houtai/charge/loadChargeUserList"  , params) };
// 创建收银系统商户
export const saveChargeUser = (params) => { return req("post", "/yunyue-houtai/charge/saveChargeUser"  , params) };
// 修改收银用户状态
export const updateUserStatus = (params) => { return req("post", "/yunyue-houtai/charge/updateUserStatus"  , params) };
// 获取地区列表
export const getAreaList = (params) => { return req("post", "/yunyue-houtai/admin/getAreaList"  , params) };
// 获取城市列表
export const AreaList = (params) => { return req("get", "/yunyue-houtai/area/list"  , params) };
// 热门城市列表
export const acticeCity = (params) => { return req("get", "/yunyue-houtai/acticecity/all"  , params) };
// 获取地区列表不分组
export const getCity = (params) => { return req("get", "/yunyue-houtai/area/city"  , params) };
// 删除热门城市
export const acticecityDel = (params) => { return req("get", `/yunyue-houtai/acticecity/del/${params}`) };
// 新增热门城市
export const acticeCityInsert = (params) => { return reqJson("post", "/yunyue-houtai/acticecity/insert"  , params) };
// 上移下移热门城市
export const acticeCityMove = (params) => { return reqJson("post", "/yunyue-houtai/acticecity/move"  , params) };
// 添加视频列表视频
export const videoAdd = (params) => { return reqJson("post", "/yunyue-houtai/video/add"  , params) };
// 获取视频管理列表
export const videoList = (params) => { return req("get", "/yunyue-houtai/video/list"  , params) };
// 视频管理删除
export const videoDel = (params) => { return req("get", `/yunyue-houtai/video/del/${params}`) };
// 获取签到奖励列表
export const signrewardsList = (params) => { return req("get", "/yunyue-houtai/signrewards/list"  , params) };
// 获取签到配置列表
export const signsettingList = (params) => { return req("get", "/yunyue-houtai/signsetting/info"  , params) };
// 修改签到奖励列表
export const signrewardsUpdate = (params) => { return reqJson("post", "/yunyue-houtai/signrewards/update"  , params) };
// 修改签到配置列表
export const signsettingUpload = (params) => { return reqJson("post", "/yunyue-houtai/signsetting/update"  , params) };
// 获取宣传页配置
export const pubpageList = (params) => { return req("get", "/yunyue-houtai/pubpage/list"  , params) };
// 添加宣传页配置
export const pubpageAdd = (params) => { return reqJson("post", "/yunyue-houtai/pubpage/add"  , params) };
// 新增游戏经验配置
export const pgmexpAdd = (params) => { return reqJson("post", "/yunyue-houtai/pgmexp/add"  , params) };
// 获取经验配置列表
export const pgmexpList = (params) => { return req("get", `/yunyue-houtai/pgmexp/order/list/${params.flag}`  , params) };
// 删除经验配置
export const pgmexpDel = (params) => { return req("get", `/yunyue-houtai/pgmexp/del/${params}`) };
// 获取上线经验值
export const gmpsettingQ = (params) => { return req("get", "/yunyue-houtai/gmpsetting/select"  , params) };
// 修改上线经验值
export const gmpsettingUpload = (params) => { return reqJson("post", "/yunyue-houtai/gmpsetting/update"  , params) };
// 新增等级
export const pgmlevelAdd = (params) => { return reqJson("post", "/yunyue-houtai/pgmlevel/add"  , params) };
// 获取等级列表
export const pgmlevelList = (params) => { return req("get", "/yunyue-houtai/pgmlevel/list"  , params) };
// 删除等级
export const pgmlevelDel = (params) => { return req("get", `/yunyue-houtai/pgmlevel/del/${params}`) };
// 修改等级
export const pgmlevelUpdate= (params) => { return reqJson("post", "/yunyue-houtai/pgmlevel/update"  , params) };
// 官方账号列表
export const officialUsersList = (params) => { return reqJson("post", `/yunyue-houtai/users/list/${params.page}/${params.size}` , params)};
// 创建官方账号
export const addUsersAdmin = (params) => { return reqJson("post", "/yunyue-houtai/users/add/admin"  , params) };
// 修改官方账号
export const usersUpdate = (params) => { return reqJson("post", `/yunyue-houtai/users/update/${params.id}`  , params) };
// 删除官方账号
export const officialUsersDel = (params) => { return reqJson("get", `/yunyue-houtai/users/del/${params.id}`) };
// 城市列表树
export const areaTree = (params) => { return reqJson("get", `/yunyue-houtai/area/tree`) };
// 添加创作中心
export const addArticle = (params) => { return reqJson("post", "/yunyue-houtai/article/add"  , params) };
// 创作中心list
export const articleList = (params) => { return reqJson("post", `/yunyue-houtai/article/list/${params.page}/${params.size}` , params)};
// 删除创作中心
export const articleDel = (params) => { return reqJson("get", `/yunyue-houtai/article/del/${params.id}`) };
// 修改创作中心
export const articleUpdate = (params) => { return reqJson("post", "/yunyue-houtai/article/update"  , params) };
// 发布创作中心
export const articleOpen = (params) => { return reqJson("get", `/yunyue-houtai/article/open/${params.id}/${params.status}`) };
// 查看评论
export const commentList = (params) => { return reqJson("get", `/yunyue-houtai/comment/list/${params.id}/${params.page}/${params.size}`) };
// 删除评论
export const commentDel = (params) => { return reqJson("get", `/yunyue-houtai/comment/del/${params.id}`) };
// 所有评论列表
export const commentSelect = (params) => { return reqJson("post", `/yunyue-houtai/comment/select/${params.page}/${params.size}` , params ) };
// 增减约豆
export const addUsersIntegral = (params) => { return reqJson("get", `/yunyue-houtai/users/addintegral/${params.id}/${params.count}/${params.type}` ) };
// 增减钻石
export const addUsersDiamond = (params) => { return reqJson("get", `/yunyue-houtai/users/diamond/${params.id}/${params.count}/${params.type}` ) };
// 用户详情
export const usersDetail = (params) => { return reqJson("get", `/yunyue-houtai/users/detail/${params.id}`) };
// 回复评论
export const commentCommit = (params) => { return reqJson("post", "/yunyue-houtai/comment/commit"  , params) };
// 获取统计列表
export const censusCount = (params) => { return reqJson("post", "/yunyue-houtai/census/count"  , params) };
// 今日-昨日数据统计
export const censusTy = (params) => { return reqJson("get", "/yunyue-houtai/census/ty"  , params) };
// 广告主用户
export const AdminChargeUserList = (params) => { return reqJson("get", "/yunyue-houtai/chargeuser/admin/list"  , params) };
// 添加广告记录
export const chargeadvAdd = (params) => { return reqJson("post", "/yunyue-houtai/chargeadv/add"  , params) };
// 广告列表
export const chargeadvList = (params) => { return reqJson("get", `/yunyue-houtai/chargeadv/list/${params.page}/${params.pageSize}` , params ) };
// 修改广告记录
export const chargeadvUpdate = (params) => { return reqJson("post", "/yunyue-houtai/chargeadv/update"  , params) };
// 删除广告记录
export const chargeadvDel = (params) => { return reqJson("get", `/yunyue-houtai/chargeadv/del/${params.id}`) };
// 获取游戏唯一标识
export const machineGamecode = (params) => { return reqJson("get", `/yunyue-houtai/addrgame/machine/gamecode`) };
// 设置城市映射游戏标识
export const addrgame = (params) => { return reqJson("post", "/yunyue-houtai/addrgame/add"  , params) };
// 获取城市地区唯一标识
export const addrgameSelect = (params) => { return reqJson("get", "/yunyue-houtai/addrgame/select"  , params) };
// 修改城市映射
export const addrgameUpdate = (params) => { return reqJson("post", "/yunyue-houtai/addrgame/update"  , params) };
// 成就上移下移
export const achieveMove = (params) => { return reqJson("get", `/yunyue-houtai/achieve/move/${params.id}/${params.flag}`) };
// 新增成就
export const achieveAdd = (params) => { return reqJson("post", "/yunyue-houtai/achieve/add"  , params) };
// 获取成就列表
export const achieveSelect = (params) => { return reqJson("get", `/yunyue-houtai/achieve/select/${params.id}`) };
// 游戏上移下移
export const pgmexpMove = (params) => { return reqJson("get", `/yunyue-houtai/pgmexp/move/${params.id}/${params.flag}/${params.order}`) };
// 新增成就次数
export const achievetimeAdd = (params) => { return reqJson("post", "/yunyue-houtai/achievetime/add"  , params) };
// 删除成就次数
export const achievetimeDel = (params) => { return reqJson("get", `/yunyue-houtai/achievetime/del/${params.id}`) };
// 删除成就
export const achieveDel = (params) => { return reqJson("get", `/yunyue-houtai/achieve/del/${params.id}`) };
// 修改成就
export const achieveUpdate = (params) => { return reqJson("post", `/yunyue-houtai/achieve/update` , params)  };
// 修改次数
export const achievetimeUpdate = (params) => { return reqJson("post", `/yunyue-houtai/achievetime/update` , params)  };
// 修改商家商户号
export const setmchid = (params) => { return reqJson("post", `/yunyue-houtai/business/setmchid` , params)  };
// 共享桌费分润
export const statistics = (params) => { return reqJson("get", `/yunyue-houtai/payorder/statistics` , params)  };
// 共享桌费echart
export const payorderEchart = (params) => { return reqJson("post", `/yunyue-houtai/payorder/echart` , params)  };
// 获取商家列表
export const storeUsers = (params) => { return reqJson("get", `/yunyue-houtai/payorder/storeUsers` , params)  };
// 共享桌费echart表格数据
export const payorderEchartDetail = (params) => { return reqJson("post", `/yunyue-houtai/payorder/echart/detail/${params.page}/${params.pageSize}` , params)  };
// 获取积分兑换比例
export const integralDivision = (params) => { return reqJson("get", `/yunyue-houtai/sysconfig/integral/division` , params)  };
// 修改积分兑换比例
export const updateIndiv = (params) => { return reqJson("post", `/yunyue-houtai/sysconfig/update/indiv` , params)  };
// 经销商列表--全量
export const storeAll = (params) => { return reqJson("get", `/yunyue-houtai/store/all` , params)  };
// 获取一级二级代理商列表
export const storeSelect = (params) => { return reqJson("post", `/yunyue-houtai/store/select/${params.page}/${params.pageSize}` , params)  };
// 查询桌费分润比例
export const divisionList = (params) => { return reqJson("post", `/yunyue-houtai/division/list` , params)  };
// 修改桌费分润比例
export const divisionUpdate = (params) => { return reqJson("post", `/yunyue-houtai/division/update` , params)  };
// 修改二级代理客服信息
export const storeUpdateFf = (params) => { return reqJson("post", `/yunyue-houtai/store/update/kf/${params.id}` , params)  };
// 查询机器详细信息
export const machineOtherDetail = (params) => { return reqJson("get", `/yunyue-houtai/machine/otherDetail/${params}`)  };
// 解绑机器
export const machineUnbind = (params) => { return reqJson("get", `/yunyue-houtai/machine/unbind/${params.id}/${params.type}`)  };
// 获取机器款式列表
export const styleList = (params) => { return reqJson("get", `/yunyue-houtai/machine/style/list`)  };
// 添加机器款式
export const styleAdd = (params) => { return reqJson("post", `/yunyue-houtai/machine/style/add` , params)  };
//删除款式
export const styleDel = (params) => { return reqJson("get", `/yunyue-houtai/machine/style/del/${params}`)  };
// 创建入库单
export const createStorageOrder = (params) => { return reqJson("post", `/yunyue-houtai/inventory/new/createStorageOrder` , params)  };
// 修改设备款式
export const updateStyle = (params) => { return reqJson("post", `/yunyue-houtai/machine/update/style/${params.id}` , params)  };
// 获取机器广告
export const advList = (params) => { return reqJson("get", `/yunyue-houtai/machine/adv/list/${params}`)  };
// 添加机器广告
export const advAdd = (params) => { return reqJson("post", `/yunyue-houtai/machine/adv/add` , params)  };
// 删除机器广告
export const DelAdv = (params) => { return reqJson("get", `/yunyue-houtai/machine/adv/del/${params}`)  };
// 修改机器广告
export const updateAdv = (params) => { return reqJson("post", `/yunyue-houtai/machine/adv/update` , params)  };
// 修改
export const machineAdv = (params) => { return reqJson("get", `/yunyue-houtai/machine/adv/${params.id}/${params.flag}`)  };
// 二级代理修改商户号
export const updateMchid = (params) => { return reqJson("post", `/yunyue-houtai/store/update/mchid` , params)};
// 收益统计
export const payorderList = (params) => { return reqJson("post", `/yunyue-houtai/payorder/list/${params.page}/${params.limit}` , params)};
// 收益导出
export const payorderExport = (params) => { return reqJson("get", `/yunyue-houtai/payorder/export` , params , 'headers')};
// 代理商修改门店开关
export const storeBranch = (params) => { return reqJson("post", `/yunyue-houtai/store/branch` , params)};
// 门店订单
export const branchOrderList = (params) => { return reqJson("post", `/yunyue-houtai/branchOrder/list/${params.page}/${params.pageSize}` , params)};
// 退款操作
export const branchRebound = (params) => { return reqJson("post", `/yunyue-houtai/branch/rebound/${params}` , params)};
// 修改收银系统gamebar开关
export const updateUserBarStatus = (params) => { return reqJson("post", `/yunyue-houtai/charge/updateUserBarStatus` , params)};
// 修改代理商有麻gamebar开关
export const storeBarbranch = (params) => { return reqJson("post", `/yunyue-houtai/store/barbranch` , params)};
// 用户强制退出
export const usersExist = (params) => { return reqJson("get", `/yunyue-houtai/users/exist/${params}` , params)};
// 获取gamebar充值配置
export const rechargeList = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/recharge/list` , params)};
// 删除gamebar充值配置
export const rechargeDel = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/recharge/del/${params}` , params)};
// 添加gamebar充值配置
export const rechargeSave = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/recharge/save` , params)};
// 获取gamebarU币配置
export const integralSettingList = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/integral/setting/list` , params)};
// 添加gamebaru币配置
export const integralSettingSave = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/integral/setting/save` , params)};
// 删除gamebarU币配置
export const integralSettingDel = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/integral/del/${params}` , params)};
// 查询gamebar订单
export const barbranchOrderList = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/order/list/${params.page}/${params.size}` , params)};
// 获取门店列表
export const branchList = (params) => { return reqJson("get", `/yunyue-houtai/branch/list` , params)};
// 修改设备地址
export const machineUpdateAddr = (params) => { return reqJson("post", `/yunyue-houtai/machine/update/addr` , params)};








// 获取所有商户列表
export const getStoreUserList = (params) => { return req("post", "/yunyue-houtai/store/getStoreUserList"  , params) };
// 获取商家列表
export const loadBusinessUserList = (params) => { return req("post", "/yunyue-houtai/business/loadBusinessUserList"  , params) };

// 获取gameBar游戏列表
export const barbranchGamelist = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/gamelist` , params)};
// 添加游戏
export const barbranchGameAdd = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/game/add` , params)};
// 删除游戏
export const barbranchGameDel = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/del/game/${params}` , params)};
// 获取游戏玩法
export const barbranchGameActionList = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/game/action/list/${params}` , params)};
// 添加游戏玩法
export const barbranchGameActionAdd = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/game/action/add` , params)};
// 删除游戏玩法
export const barbranchGameActionDel = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/del/action/${params}` , params)};
// 获取明细列表
export const barbranchGamesactionList = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/game/saction/list` , params)};
// 添加明细
export const barbranchGameSactionAdd = (params) => { return reqJson("post", `/yunyue-houtai/barbranch/game/saction/add` , params)};
// 删除明细
export const barbranchGameSactionDel = (params) => { return reqJson("get", `/yunyue-houtai/barbranch/del/saction/${params}` , params)};



























// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 用户管理 
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/

// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 角色管理-保存（添加编辑）
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 公司管理 
 **/
// 公司管理-获取公司列表
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js